import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { Tooltip } from '@mui/material';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import InfoIcon from '@mui/icons-material/Info';
import SecurityIcon from '@mui/icons-material/Security';

function Index() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {

        if (isAuthenticated && tokenIsExpired(token)) {

            logout();
            return;
        }


        fetchtableData();
    }, [isAuthenticated, companyId, token, userId, logout]);

    useEffect(() => {
        fetchtableData();
    }, []);

    const fetchtableData = async () => {

        fetchData('ExpenseApi', `/${companyId}/${userId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Expense Details:', error);
            });

    };

    const [approvedData, setApprovedData] = useState([]);

    useEffect(() => {
        fetchtableApprovedData();
    }, []);

    const fetchtableApprovedData = async () => {

        fetchData('ApprovedClaimsAPI', `/${companyId}/${userId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setApprovedData(response.response_data);

                }
            })
            .catch((error) => {
                console.error('Error fetching Expense Details:', error);
            });

    };

    const handleDelete = async () => {
        deleteData('ExpenseApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ExpenseApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData();
            })
            .catch((error) => {

            });
    };


    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };


    // // items list 
    // const [itemdata, setItemData] = useState([]);
    // const id = data.id;

    // useEffect(() => {
    //     fetchData('ExpenseApi', `/ ExpenseDetails/${id}`, token)
    //         .then((response) => {
    //             if (response.responseCode === '1111') {
    //                 setItemData(response.response_data);
    //                 console.log(response);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Sale Details:', error);
    //         });
    // }, [id]);

    // const [isApprovedItemModalOpen, setIsApprovedItemModalOpen] = useState(false);
    // const handleApprovedModalOpen = () => {
    //     setIsApprovedItemModalOpen(true);
    // };

    // const handleApprovedModalClose = () => {
    //     setIsApprovedItemModalOpen(false);
    // };
    const [itemData, setItemData] = useState([]);
    const [isApprovedItemModalOpen, setIsApprovedItemModalOpen] = useState(false);
    const [selectedItemId, setSelectedItemId] = useState(null);

    useEffect(() => {
        if (selectedItemId) {
            fetchData('ExpenseApi', `/ExpenseDetails/${selectedItemId}`, token)
                .then((response) => {
                    if (response.responseCode === '1111') {
                        setItemData(response.response_data);
                        console.log(response);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching Sale Details:', error);
                });
        }
    }, [selectedItemId]);

    const handleApprovedModalOpen = (itemId) => {
        setSelectedItemId(itemId);
        setIsApprovedItemModalOpen(true);
    };

    const handleApprovedModalClose = () => {
        setIsApprovedItemModalOpen(false);
    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className='w-full mb-2 flex items-center'>
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>DAILY EXPENSE</h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>

                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
                <Tooltip title="Claims Details">
                    <Button onClick={openModal} style={{ color: 'darkred', fontWeight: 'bolder' }} disabled={isLoading}>
                        <CheckCircleOutlineIcon /> {isLoading ? <CircularProgress size={24} color="inherit" /> : "Claimed"}
                    </Button>
                </Tooltip>
                ||
                <Tooltip title="Create Expense Sheet">
                    <Link to="/ExpenseEntryPage" className="inline-block">
                        <Button style={{ fontWeight: 'bolder' }}>
                            <AddIcon /> Create
                        </Button>
                    </Link>
                </Tooltip>
            </div>


            <Modal open={isApprovedItemModalOpen} className={isApprovedItemModalOpen ? 'notification-modal' : ''} onBackdropClick={handleApprovedModalClose}>
                <div className="notification-modal" style={{ backgroundColor: 'white', maxHeight: '400px', overflow: 'auto' }}>
                    <br></br>
                    <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkred', }}><SecurityIcon style={{ color: 'darkcyan' }} />  Claims Status</h4>
                    <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">
                        <table>
                            <thead>
                                <tr className="bg-gray-200 border-b">
                                    <th className="px-4 py-2 text-left border-r" style={{ width: '5px' }}>Sl.no</th>
                                    <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Expense</th>
                                    <th className="px-4 py-2 text-left border-r" style={{ width: '500px' }}>Note</th>
                                    <th className="px-4 py-2 text-left border-r" style={{ width: '150px' }}>Amount</th>
                                    <th className="px-4 py-2 text-left border-r" style={{ padding: '8px' }}>Action</th>

                                </tr>
                            </thead>
                            <tbody style={{ backgroundColor: ' white' }}>
                                {itemData.map((item, index) => (
                                    <tr key={index} className={`${item.isApproved ? 'bg-green-200' : ''} ${item.isRejected ? 'bg-red-200' : ''}`}>

                                        <td className="px-4 py-2 border-r" style={{ width: '5px' }}>{index + 1}</td>
                                        <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.expenseName}</td>
                                        <td className="px-4 py-2 border-r" style={{ width: '500px' }}>{item.note}</td>
                                        <td className="px-4 py-2 border-r" style={{ width: '150px', textAlign: 'right', cursor: 'pointer' }}>{item.amount}</td>

                                        <Fragment>
                                            {item.isApproved && (
                                                <td style={{ padding: '8px', marginTop: '-15px' }}>
                                                    <span style={{ color: 'green', marginLeft: '20px' }}>Approved</span>
                                                </td>
                                            )}
                                            {item.isRejected && (
                                                <td style={{ padding: '8px', marginTop: '-15px' }}>
                                                    <span style={{ color: 'red', marginLeft: '20px' }}>Rejected</span>
                                                </td>
                                            )}

                                        </Fragment>
                                    </tr>
                                ))}



                            </tbody>
                        </table>
                    </div>
                </div>
            </Modal>

            <Modal open={isModalOpen} className={isModalOpen ? 'notification-modal' : ''} onBackdropClick={handleCloseModal}>
                <div className="notification-modal" style={{ backgroundColor: 'white', maxHeight: '400px' }}>
                    <br></br>
                    <h4 style={{ textAlign: 'center', fontFamily: 'Times New Roman', fontWeight: 'bolder', color: 'darkgreen', }}>Claims</h4>
                    <div className="bg-tabcolor-100 rounded-lg shadow-lg p-6">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '14px' }}>Sl.no</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px' }}>E.Date</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px' }}>Amount</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px' }}>Info</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {approvedData.map((item, index) => (
                                        <TableRow key={item.Id}>
                                            <TableCell sx={{ fontSize: '14px', padding: '5px' }}>{index + 1}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '5px' }}>
                                                {item.expenseEntryDate && new Date(item.expenseEntryDate).toLocaleDateString('en-GB')}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '5px' }}>{item.amount}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '5px' }}>
                                                {/* <Link to={`/ExpenseEditPage/${item.id}`}>
                                                    <IconButton>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Link> */}

                                                <IconButton onClick={() => handleApprovedModalOpen(item.id)}>
                                                    <InfoIcon />
                                                </IconButton>

                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                </div>

            </Modal>

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', color: 'white', textTransform: 'uppercase', padding: '5px' }}>Sl.no</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', color: 'white', textTransform: 'uppercase', padding: '5px' }}>E.Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', color: 'white', textTransform: 'uppercase', padding: '5px' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', color: 'white', textTransform: 'uppercase', padding: '5px' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', color: 'white', textTransform: 'uppercase', padding: '5px' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>

                            {filteredData.map((item, index) => (
                                <TableRow key={item.Id}>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>
                                        {item.expenseEntryDate && new Date(item.expenseEntryDate).toLocaleDateString('en-GB')}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.engineerName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>{item.amount}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #000000', fontSize: '13px', padding: '5px' }}>
                                        <Link to={`/ExpenseEditPage/${item.id}`}>
                                            <IconButton>
                                                <EditIcon style={{ color: 'darkblue' }} />
                                            </IconButton>
                                        </Link>

                                        <IconButton onClick={() => openConfirmDialog(item.id)}>
                                            <DeleteIcon style={{ color: 'darkred' }} />
                                        </IconButton>

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div >
    );
}

export default Index;

